export default {
    translation: {

    }
};
